import type { DrugFormData } from '@/api/domains/drugs.api';
import type { Drug } from '@/api/domains/drugs.types';

export const getRequiredDrugFormData = (drug: Drug): DrugFormData => ({
  name: drug.name,
  category_id: drug.category_id,
  maker_id: drug.maker_id,
  measure_unit_id: drug.measure_unit_id,
  vat_id: drug.vat_id,
  maker_name: drug?.maker?.name ?? '',
  country_name: drug?.maker?.country ?? '',
});
